import React from 'react';
import {StaticQuery, graphql} from 'gatsby';
import styled from 'styled-components';
import { colors, fonts, breakingpoints } from '../constant/style';
import { SocialMediasLinks } from '../constant/routes';

import Cloudinary from './Cloudinary';

const Section = styled.section`
  text-align: center;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 400;
  ${breakingpoints.small} {
    font-size: 22px;
  }
`;

const Link = styled.a`
  color: ${colors.alpha};
  font-size: 22px;
  text-decoration: none;
  font-family: ${fonts.beta};
  ${breakingpoints.small} {
    font-size: 16px;
  }
`;

const Images = styled.div`
  display: flex;
  flex-flow: row wrap;
  max-width: 1200px;
  margin: 25px auto;
  padding: 0 10px;
  justify-content: center;
  @media screen and (max-width: 599px) {
    justify-content: flex-start;
  }
`;

const Image = styled.a`
  flex: 0 1 auto;
  width: 20%;
  overflow: hidden;
  padding: 20px 10px;
  @media screen and (max-width: 850px) {
    width: 25%;
    &:last-child {
      display: none;
    }
  }
  @media screen and (max-width: 600px) {
    width: 50%;
  }
`;

class InstagramGallery extends React.Component {
  render() {
    return (
      <Section>
        <Title>Suivez nous sur Instagram</Title>
        <Link href={SocialMediasLinks.instagram}>@clemencetaillez</Link>
        <Images>
          {this.props.data.allInstagramPost.edges.map(({ node: {id, media_url, permalink, username} }) => {
            return (
              <Image
                key={id}
                href={permalink}
                title={`@${username}`}
              >
                <Cloudinary 
                  src={media_url}
                  sizes='(min-width: 600px) 220px, 50vw'
                  srcset={[220,440]}
                  params={['c_fill','ar_1:1','g_face']}
                />
              </Image>
            )
          })}
        </Images>
      </Section>
    );
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        allInstagramPost(sort: {fields: timestamp, order: DESC}, limit: 5) {
          edges {
            node {
              id
              media_type
              media_url
              permalink
              timestamp
              username
            }
          }
        }
      }
    `}
    render={data => <InstagramGallery data={data} {...props} />}
  />
);
